export const userStorageKey = 'cs-broadcast-web-user';
